import React from 'react';
import { getStore, setStore, setLogin, getLogin, removeLogin } from '../../functions/storage';

export const DataContext = React.createContext({ dataStore: {} });

export default class Provider extends React.Component {
  state = {
    dataStore: getStore() ? getStore() : {},
    loggedIn: getLogin() ? getLogin().loggedIn : false,
    dateLoggedIn: getLogin() ? getLogin().dateLoggedIn : undefined,
  };

  handleDataStoreChange = dataStore => {
    this.setState({ dataStore });
    setStore(dataStore);
  }

  login = () => {
    const loginObject = {
      loggedIn: true,
      dateLoggedIn: new Date(),
    };
    this.setState({
      loggedIn: loginObject.loggedIn,
      dateLoggedIn: loginObject.dateLoggedIn,
    });
    setLogin({ loginObject });
  }

  logOut = () => {
    this.setState({ loggedIn: false, dateLoggedIn: null });
    removeLogin();
  }

  render() {
    return (
      <DataContext.Provider
        value={{
          ...this.state,
          handleDataStoreChange: this.handleDataStoreChange,
          login: this.login,
          logOut: this.logOut,
        }}
      >
        {this.props.children}
      </DataContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/api/contextApi/DataProvider.js